import styled from 'styled-components';
import { BodyRegularM, BodyRegularS, CaptionRegularM } from '../../../../styles/globals';
import { IThemeProvider, ITheme } from '../../../../styles/theme';

export const PredictiveTileAccCont = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  border-radius: 8px;

  ${({ theme }: IThemeProvider) => `
    margin: 0 0 ${theme.layout.spacing.mikro} 0;
    padding: 0 ${theme.layout.spacing.centy} 0 32px;
    background: ${theme.colors.neutral.primary[0]};
    border-bottom: 1px solid ${theme.colors.neutral.primary[30]};
  `};
`;

export const PredictiveTileAccHeadCont = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[80]};
  `};
`;

export const PredictiveTileHeadSide = styled.div`
  position: relative;
  display: flex;
  height: 52px;
  align-items: center;
  flex: 3;
  cursor: pointer;

  ${({ theme }: IThemeProvider) => `
    padding: 0 ${theme.layout.spacing.decy} 0 0;
  `}
`;

export const ChartCont = styled.div`
  flex: 4;
`;

interface IAccArrowCont {
  active?: boolean;
  theme: ITheme;
}

export const PredAccArrowCont = styled.div<IAccArrowCont>`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  svg {
    width: 10px;
    height: 5px;
    position: relative;
    top: -2px;
    ${({ active }) => `
    ${
  !active
    ? `
      transform: rotate(-90deg);
      top: -2px;
    `
    : ''
}
  `};
  }
`;

export const ExpColumnCont = styled.div`
  position: relative;
  width: calc(100% / 3);
`;

export const PredAccTitle = styled(BodyRegularS)`
  flex: 1;
  font-weight: 500;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[90]};
  `};

  //width: calc(100% / 3);
  //width: 180px;

  //@media (min-width: 1360px) {
  //  width: 482px;
  //}
`;

export const PredScoreVal = styled(BodyRegularM)`
  min-width: 105px;
  display: flex;
  font-size: 20px;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;

  ${({ theme }: IThemeProvider) => `
    color: ${theme.colors.neutral.primary[100]};
  `};
`;

export const ScoreTrendCont = styled.div`
  // ${({ theme }: IThemeProvider) => `
  //      margin: 0 0 0 ${theme.layout.spacing.mikro};
  // `};
`;

export const PredicAccBodyCont = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  box-sizing: border-box;
  max-width: 100%;

  ${({ theme }: IThemeProvider) => `
    margin: 0 0 ${theme.layout.spacing.mili} 34px;
    color: ${theme.colors.neutral.primary[80]};
  `};
`;

export const PredicAccDesc = styled(CaptionRegularM)`
  margin-bottom: 14px;
  font-size: 14px;
  line-height: 18px;
`;

export const LittleWormChartCont = styled.div`
  width: 100%;
`;

export const ExampleStatementCont = styled.div`
  margin-top: 4px;
`;

export const ExampleStatementTitle = styled(CaptionRegularM)`
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
`;

export const ExampleStatement = styled(CaptionRegularM)`
  font-style: italic;
  font-size: 14px;
  line-height: 18px;
`;
